module.exports = __webpack_public_path__ + "img/fully-grown-tree.5f3ac3de.webp";